$(document).on('click.Footer', '.footer_hidden-on-phones > button', function () {
    var $hiddenOnPhones = $(this).parent();
    $hiddenOnPhones.parent()
        .find('.footer_hidden-on-desktops')
        .removeClass('footer_hidden-on-desktops');
    $hiddenOnPhones.remove();
});